import { render } from "./Show.vue?vue&type=template&id=3eb03805"
const script = {}

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__